import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { CountdownComponent } from "ngx-countdown";
import { timer } from 'rxjs';

@Component({
  selector: "timer",
  templateUrl: "./timer.component.html",
  styleUrls: ["./timer.component.css"],
})
export class TimerComponent implements OnInit {
  @ViewChild('countdown', { static: true }) private countdown: CountdownComponent;

  @Output() timerEvent: any = new EventEmitter<any>();

  @Input() timmerStatus;
  @Input() duration;

  public config: any = { leftTime: 1200, notify: [300], format: 'mm:ss' };
  public warning: boolean = false;
  // this.countdown.begin();

  constructor() {

  }

  ngOnInit() {
  }
  // public countEvent:any;
  handleEvent(e) {
    if (e.left === 300000) {
      this.warning = true;
    }
    if (e.action == 'done') setTimeout(() => this.countdown.restart());
    this.timerEvent.emit(e);
  }

  ngOnChanges(): void {
    this.warning=false;
    this.config.leftTime = this.duration;
    if(this.timmerStatus=='stop')
      this.countdown.stop();
    else if(this.timmerStatus=="restart")  this.countdown.restart();

  }
}
